






































import { defineComponent, toRefs, PropType, ref, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  IDENTITY_AVAILABLE_STATUS,
  IdentityInfo,
  IDENTITY_TYPE_MAP,
} from '@tt4b/ttam-enums';
import TtamAffiliateIdentitySelectPopover from './affiliate-identity-select-popover/index.vue';
import { useStore, StateEnum } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../utils/index';
import Identity from './index';
import { useAffiliateTikTokListDataSource } from './hooks';

const name = 'ttam-affiliate-identity-compose';
export default defineComponent({
  name,
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    curIdentityInfo: {
      type: Object as PropType<IdentityInfo>,
      default: () => ({}),
    },
    isLoading: { type: Boolean, default: false },
  },
  components: {
    TtamAffiliateIdentitySelectPopover,
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData } = toRefs(props);
    const {
      dataSource: identityList,
      tikTokAccountOriginalData,
      getAffilidateIdentityList,
      isLoading: isIdentityListLoading,
    } = useAffiliateTikTokListDataSource({
      campaignData,
      adgroupData,
    });
    const identitySelectPopoverVisible = ref(false);
    const { state } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value?.aadvid);
    const handleIdentityListRefresh = () => {
      trackEvent('ad_start_with_product_authorize_account_refresh');
      getAffilidateIdentityList();
    };
    const emitTiktokAccount = (data: IdentityInfo) => {
      emit('identity-change', {
        identityId: '',
        ...data,
        identityType: IDENTITY_TYPE_MAP.TT_USER,
      });
    };
    const onLinkFail = data => {
      emit('link-fail', data);
      trackEvent('upgrade_identity_ttba_tab_authorize_failed', {
        isAffiliate: true,
      });
    };
    const onUnLinkSuccess = async () => {
      await getAffilidateIdentityList();
      emitTiktokAccount(tikTokAccountOriginalData.value);
      trackEvent('upgrade_identity_unlink_success', {
        isAffiliate: true,
      });
    };
    const { onLink, onUnLink, updateTTBA } = Identity.useTikTokAccountEvents({
      oauthConfig: ref({
        extraParam: {
          scene: 'bind',
          aadvid,
        },
      }),
      onLinkSuccess: async data => {
        await getAffilidateIdentityList();
        emitTiktokAccount(tikTokAccountOriginalData.value);
        const accountStatus = tikTokAccountOriginalData.value?.availableStatus;
        // 去升级企业号
        if (accountStatus === IDENTITY_AVAILABLE_STATUS.NOT_BUSINESS_ACCOUNT) {
          await updateTTBA('ttba-container');
          await getAffilidateIdentityList();
          emitTiktokAccount(tikTokAccountOriginalData.value);
        }
        emit('link-success', data);
        trackEvent('upgrade_identity_ttba_tab_authorize_success', {
          isAffiliate: true,
        });
      },
      onLinkFail,
      onUnLinkSuccess,
    });
    const handleIdentityChange = (identityInfo: IdentityInfo) => {
      emit('identity-change', identityInfo);
      identitySelectPopoverVisible.value = false;
      trackEvent('ad_start_with_product_switch_identity');
    };
    const openAuthorizePostDrawer = () => {
      trackEvent('ad_start_with_product_authorize_post_start');
      emit('open-authorize-post-drawer');
    };
    const handleAccountAdd = () => {
      trackEvent('ad_start_with_product_authorize_account_add_account');
      onLink();
    };
    const handleAccountUnlink = () => {
      trackEvent('ad_start_with_product_authorize_account_unlink_account');
      onUnLink();
    };
    return {
      name,
      identitySelectPopoverVisible,
      openAuthorizePostDrawer,
      handleIdentityChange,
      handleIdentityListRefresh,
      identityList,
      isIdentityListLoading,
      handleAccountAdd,
      handleAccountUnlink,
      onLinkFail,
      onUnLinkSuccess,
    };
  },
});
